export default {
  screenWidth: 10000,
  screenHeight: 0,
  isActiveItem: false,
  portraitOrientation: false,
  isOpenCloseNotificationMenu: false,
  isDocumentsBannerClosed: false,
  isOpenMobileMenu: false,
};
